<template>
  <v-container>
    <h1>Check Translations</h1>

    <progress-component script="CheckTranslations"></progress-component>
  </v-container>
</template>

<script>

import ProgressComponent from '../components/ProgressComponent.vue';

export default {
  name: 'CheckTranslations',
  components: { ProgressComponent },
};
</script>
